import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    effect,
    inject,
    signal
} from "@angular/core";
import { TableValuesComponent } from "@app/views/auth/report/components/report-visualization-explore/table-values/table-values.component";
import { AboutVisualizationComponent } from "@app/views/auth/report/components/report-visualization-explore/about-visualization/about-visualization.component";
import {
    ReportEntity,
    CompanyEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { DrilldownComponent } from "./drilldown/drilldown.component";
import { CommonModule } from "@angular/common";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { DeviceService } from "@shared/services/device.service";
import { EventsService } from "@arch/domain/application/services/events.service";
@Component({
    selector: "app-report-visualization-explore",
    imports: [CommonModule, SharedDsnModule, SharedMaterialModule],
    templateUrl: "./report-visualization-explore.component.html",
    styleUrl: "./report-visualization-explore.component.scss"
})
export class ReportVisualizationExploreComponent implements OnInit {
    @Input({ required: false }) loading: boolean;
    @Input() report: ReportEntity;
    @Input() company: CompanyEntity;
    @Input() visualization: VisualizationEntity;
    @Input() public set hasPoints(value: boolean) {
        this.hasValidData.set(value);
    }
    @Output() handleSelectVisualizationDrillDown =
        new EventEmitter<VisualizationEntity>();

    public get hasPoints() {
        return this.hasValidData();
    }

    public hasValidData = signal<boolean>(false);
    public currentPage: number = 2;
    public exploreTabs: ExploreTab[] = [
        {
            label: "Sobre",
            value: 2
        }
    ];

    private readonly deviceService = inject(DeviceService);
    public isMobile = this.deviceService.getIsMobile();
    private readonly eventsService = inject(EventsService);
    protected readonly drilldownComponent = DrilldownComponent;
    protected readonly tableValuesComponent = TableValuesComponent;
    protected readonly aboutVisualizationComponent =
        AboutVisualizationComponent;

    constructor() {
        effect(() => {
            if (this.hasValidData()) {
                this.currentPage = 0;
                this.exploreTabs = [
                    {
                        label: "Contas",
                        value: 0
                    },
                    {
                        label: "Valores",
                        value: 1
                    },
                    {
                        label: "Sobre",
                        value: 2
                    }
                ];
            }
        });
    }

    ngOnInit(): void {
        if (!this.visualization.tableValues) {
            this.exploreTabs = [
                {
                    label: "Contas",
                    value: 0
                },
                {
                    label: "Sobre",
                    value: 2
                }
            ];
        }
    }

    public onChangePage(page: number): void {
        this.currentPage = page;
    }

    public onVisualizationClick = (
        visualization: VisualizationEntity
    ): void => {
        this.eventsService.send(
            `Dash.${this.report.type}.${this.report.humanSourceName}.explorar-contas`
        );
        this.handleSelectVisualizationDrillDown.emit(visualization);
    };
}
type ExploreTab = {
    label: string;
    value: number;
};
